"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
exports["default"] = (function (props) {
    var data = props.data, title = props.title;
    var header = title && (react_1["default"].createElement(core_1.Typography, { variant: "h6", color: "textSecondary", gutterBottom: true }, title));
    return (react_1["default"].createElement(core_1.TableContainer, { component: core_1.Paper, style: { padding: '10pt' } },
        header,
        react_1["default"].createElement(core_1.Table, { size: "small" },
            react_1["default"].createElement(core_1.TableBody, null, data.map(function (d) {
                return (react_1["default"].createElement(core_1.TableRow, null,
                    react_1["default"].createElement(core_1.TableCell, null,
                        react_1["default"].createElement(core_1.Typography, { component: "b", color: "textSecondary" }, d.key)),
                    react_1["default"].createElement(core_1.TableCell, null, d.value)));
            })))));
});
